export const PROGRAM_VENUE = [
    {
        "value": "Homebased",
        "label": "Home-based"
    },
    {
        "value": "Schools",
        "label": "School"
    },
    {
        "value": "Companypremises",
        "label": "Company premises"
    },
    {
        "value": "Computerlab",
        "label": "Computer laboratory"
    },

    {
        "value": "Mobilephonebased",
        "label": "Mobile phone-based"
    },
    {
        "value": "Outdoorpremises",
        "label": "Outdoor premises"
    },
    {
        "value": "PCMacbased",
        "label": "PC/Mac-based"
    },
    {
        "value": "TrainingCentre",
        "label": "Training Centre"
    },
    // {
    //     "value": "MuseumExhibition",
    //     "label": "Museum / Exhibition"
    // },
    // {
    //     "value": "Online",
    //     "label": "Online"
    // },
    // {
    //     "value": "Others",
    //     "label": "Others"
    // }
];

export const PROGRAM_VENUE_MAP = {
    "Homebased": {
        "label": "Home-based"
    },
    "Schools": {
        "label": "School"
    },
    "Companypremises": {
        "label": "Company premises"
    },
    "Computerlab": {
        "label": "Computer laboratory"
    },

    "Mobilephonebased": {
        "label": "Mobile phone-based"
    },
    "Outdoorpremises": {
        "label": "Outdoor premises"
    },
    "PCMacbased": {
        "label": "PC/Mac-based"
    },
    "TrainingCentre": {
        "label": "Training Centre"
    },
    // "MuseumExhibition": {
    //     "label": "Museum / Exhibition"
    // },
    // "Online": {
    //     "label": "Online"
    // },
    // "Others": {
    //     "label": "Others"
    // }
};